import React from "react";
import { EditorBlock } from "draft-js";
import PropTypes from "prop-types";

import ImageDisplay from "./ImageDisplay";

import Placeholder from "editor/components/Placeholder";
import { IMAGE_CAPTION_PLACEHOLDER } from "config/constants/editor";

import styles from "./Image.css";

export default class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = { imageElement: null };
  }

  isPlaceholderVisible() {
    return this.props.block.getText().length === 0;
  }

  render() {
    const imgSrc = this.props.block.getData().get("src");
    const alt_text = this.props.block.getData().get("alt_text");

    return (
      <div className={styles.root}>
        <figure>
          <ImageDisplay
            imgSrc={imgSrc}
            alt_text={alt_text}
            blockKey={this.props.block.getKey()}
          />
          <figcaption>
            <Placeholder isVisible={this.isPlaceholderVisible()}>
              {IMAGE_CAPTION_PLACEHOLDER}
            </Placeholder>
            <EditorBlock {...this.props} />
          </figcaption>
        </figure>
      </div>
    );
  }
}

Image.propTypes = {
  block: PropTypes.object.isRequired,
};
